import type { ThreadStatus } from './types';
import { Badge } from '../components';

const STATUS_CONFIG: Record<ThreadStatus, { label: string; variant: 'default' | 'success' | 'warning' | 'error' | 'info' }> = {
    open: { label: 'Open', variant: 'info' },
    in_progress: { label: 'In Progress', variant: 'warning' },
    replied: { label: 'Replied', variant: 'success' },
    resolved: { label: 'Resolved', variant: 'default' },
    wont_fix: { label: "Won't Fix", variant: 'default' },
    closed: { label: 'Closed', variant: 'default' },
};

export function ThreadStatusBadge({ status }: { status: ThreadStatus }) {
    const config = STATUS_CONFIG[status] || STATUS_CONFIG.open;
    return <Badge variant={config.variant} size="sm">{config.label}</Badge>;
}
